export const coherentDirectDebitStyles = () => ({});
